import { Flex, List, Spoiler, Table, Text } from '@mantine/core'
import { IconBan, IconCheck, IconLineDashed } from '@tabler/icons-react'
import { useTranslate } from 'react-admin'
import { DateHelper } from '../../helpers/Date.helper'
import { LXTableDataType } from '../../types/components/Table.type'
// import type { LXTableDataType } from '../../types/LXTableColumn.type'

import styles from './LXTable.module.scss'

type LXTdProps = {
  data: boolean | string | object | JSX.Element[]
  maxHeight?: number
  type?: LXTableDataType
}

export const LXTd = ({ data, type, maxHeight = 85 }: LXTdProps) => {
  const { isValidDate, format } = DateHelper
  let formattedData: JSX.Element | JSX.Element[] | string = <></>
  const translate = useTranslate()

  switch (type) {
    case 'boolean':
      if (data === true) {
        formattedData = <IconCheck size={20} color="green" />
      } else if (data === false) {
        formattedData = <IconBan size={16} color="red" />
      } else {
        formattedData = <IconLineDashed size={16} color="grey" />
      }
      break
    case 'boolean-single':
      formattedData =
        typeof data === 'string' ? (
          <IconCheck size={20} color="green" />
        ) : (
          <IconLineDashed size={16} color="grey" />
        )
      break
    case 'list':
      formattedData = (
        <Spoiler
          maxHeight={maxHeight}
          showLabel={translate('_generics.displayMore')}
          hideLabel={translate('_generics.hide')}
          onClick={e => e.stopPropagation()}
        >
          <List size="sm">
            {(data as []).map(d => (
              <List.Item key={d}>{d}</List.Item>
            ))}
          </List>
        </Spoiler>
      )
      break
    case 'date':
      formattedData = isValidDate(data as string) ? (
        format(data as string)
      ) : (
        <Text size="sm" c="dimmed">
          {translate('_generics.notProvided')}
        </Text>
      )
      break
    case 'actions':
      formattedData = (
        <Flex direction="column" justify="center" align="flex-start">
          {(data as []).map(d => d)}
        </Flex>
      )
      break
    case 'actions-inline':
      formattedData = (
        <Flex direction="row" justify="center" align="flex-start">
          {(data as []).map(d => d)}
        </Flex>
      )
      break
    case 'paragraph':
      formattedData = (
        <Spoiler
          maxHeight={70}
          showLabel={translate('_generics.displayMore')}
          hideLabel={translate('_generics.hide')}
          onClick={e => e.stopPropagation()}
        >
          {data?.toString()}
        </Spoiler>
      )
      break
    case 'component':
      formattedData = data as JSX.Element
      break
    default:
      formattedData = data?.toString() || ''
  }

  return <Table.Td className={styles.td}>{formattedData}</Table.Td>
}
